export const isIndividual = rsc => /GRY.1AA-.+/.test(rsc);

export const isGroups = rsc => /GRY.5AA-.+/.test(rsc);

export const isFinal = rsc => /GRY..AA---------------FNL.+/.test(rsc);